<div class="container">

    <mat-card>
        <mat-card-content>
            <ng-container *ngIf="submiting">
                <mat-progress-spinner mode="indeterminate" [diameter]="40"></mat-progress-spinner>
            </ng-container>
            <ng-container *ngIf="!submiting">
                <div class="wrapper">
                    <p class="mat-title" style="text-align: center">
                        Olá, você esta sendo convidado para o processo selectivo {{processList.sinonimo}} da
                        empresa {{processList.companyname}}, clique no botão abaixo para participar participar.
                    </p>
                    <button mat-stroked-button color="primary" (click)="goto()">Ir para processo seletivo</button>
                </div>
            </ng-container>
        </mat-card-content>
    </mat-card>

</div>